module.exports = __webpack_public_path__ + "img/bz.44ca8d75.svg";